// extracted by mini-css-extract-plugin
module.exports = {"root":"dd31006766--root--uolVI","button":"dd31006766--button--bTtJ7","mobile":"dd31006766--mobile--TzsMF"};